import { onResetSearchFilter } from './search';
import { resetMonth } from './date';
import { resetSortData } from './sort';

export function resetFiltersCampaigns() {
  onResetSearchFilter();
  resetMonth();
  resetSortData();
}
